"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelEditState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const observable_map_1 = require("../util/observable.map");
class FormModelEditState extends core_shared_1.FormModelState {
    get id() { return this.internalState.id; }
    get revision() { return this.internalState.revision; }
    get version() { return this.internalState.version; }
    get rootFormId() { return this.internalState.rootFormId; }
    get name() { return this.internalState.name; }
    get updatedAt() { return this.internalState.updatedAt; }
    get createdAt() { return this.internalState.createdAt; }
    get updatedBy() { return this.internalState.updatedBy; }
    get v() { return this.internalState.v; }
    get metadata() { return this.internalState.metadata; }
    constructor(form) {
        super(form);
        this.fields = new observable_map_1.ObservableIMap();
        this.properties = new observable_map_1.ObservableIMap();
        this.internalState = form.state;
        this.setDisplayName(form.displayName);
        this.setDescription(form.description);
    }
    get dirty() {
        if (this.internalState.fields.size > 0 && this.fields.size > 0) {
            return true;
        }
        return this.fields.size > 0 || this.internalState.displayName !== this.displayName || this.internalState.description !== this.description;
    }
    get valid() {
        for (const field of Array.from(this.fields.values())) {
            if (field.displayName == null || field.displayName.trim().length === 0) {
                return false;
            }
        }
        return true;
    }
    get isDirty() {
        if (this.internalState.fields.size > 0 && this.fields.size > 0) {
            return true;
        }
        return this.fields.size > 0 || this.properties.size > 0;
    }
    reset() {
        this.fields.clear();
        this.properties.clear();
    }
    get displayName() {
        return this.getProperty('displayName');
    }
    get description() {
        return this.getProperty('description');
    }
    setDisplayName(displayName) {
        this.setProperty('displayName', displayName);
    }
    setDescription(description) {
        this.setProperty('description', description);
    }
    getProperty(propertyName) {
        if (this.properties.has(propertyName)) {
            return this.properties.get(propertyName);
        }
        return this.internalState[propertyName];
    }
    setProperty(propertyName, value) {
        let internalValue = this.internalState[propertyName];
        if (JSON.stringify(value) === JSON.stringify(internalValue)) {
            this.properties.delete(propertyName);
        }
        else {
            this.properties.set(propertyName, value);
        }
    }
    getFieldValue(fieldId) {
        if (this.fields.has(fieldId)) {
            return this.fields.get(fieldId);
        }
        return this.internalState.getFieldValue(fieldId);
    }
    setFieldValue(fieldId, state) {
        let internalValue = this.internalState.getFieldValue(fieldId);
        if (JSON.stringify(state) === JSON.stringify(internalValue)) {
            this.fields.delete(fieldId);
        }
        else {
            this.fields.set(fieldId, state);
        }
    }
}
exports.FormModelEditState = FormModelEditState;
tslib_1.__decorate([
    mobx_1.computed
], FormModelEditState.prototype, "dirty", null);
tslib_1.__decorate([
    mobx_1.computed
], FormModelEditState.prototype, "valid", null);
tslib_1.__decorate([
    mobx_1.computed
], FormModelEditState.prototype, "isDirty", null);
tslib_1.__decorate([
    mobx_1.action
], FormModelEditState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], FormModelEditState.prototype, "setDisplayName", null);
tslib_1.__decorate([
    mobx_1.action
], FormModelEditState.prototype, "setDescription", null);
tslib_1.__decorate([
    mobx_1.action
], FormModelEditState.prototype, "setProperty", null);
tslib_1.__decorate([
    mobx_1.action
], FormModelEditState.prototype, "setFieldValue", null);
//# sourceMappingURL=form.edit.model.js.map